export default "__VITE_ASSET__v1Le2il3__"